import React, { Component } from 'react';
import styled from 'styled-components';
import StyledButton from './MainButton.style';
import media from './MediaQueries';

// override StyledMainButton if needed.
const StyledNextButton = styled(StyledButton)`
  ${media.phone`
    margin-bottom: auto;
    height: 44px;
  `}

  &:active {
    transform: scale3d(1.1, 1.1, 1);
    border: 3px solid #ffaa5f;
  }
`;

class NextPageButton extends Component {
  render() {
    return (
      <StyledNextButton
        onClick={this.props.nextPage}
        align={this.props.options.align}
        style={this.props.options.style}
        onTouchStart={null}
        className={this.props.options.className}
      >
        {this.props.options.title}
      </StyledNextButton>
    );
  }
}

export default NextPageButton;



// WEBPACK FOOTER //
// ./src/components/instore/NextPageButton.js